import Modal from 'antd/es/modal';
import React from 'react';
import { useTheme } from 'styled-components';

import type { AgentConfigurationVersion } from '../../../queries/agent-configuration-versions';
import { RunAgentComponent } from '../../RunAgent/RunAgent.component';
import type { RunAgentConfig } from '../../RunAgent/RunAgent.utils';

interface RunAgentModalProps {
  open: boolean;
  onClose: () => void;
  agentId: string;
  configurationVersion: AgentConfigurationVersion;
  teamId?: string;
  onExecutionCreated?: (executionId: string) => void;
  shouldNavigateToExecutions?: boolean;
}

export const RunAgentModal: React.FC<RunAgentModalProps> = ({
  open,
  onClose,
  agentId,
  configurationVersion,
  teamId,
  onExecutionCreated,
  shouldNavigateToExecutions = true,
}) => {
  const theme = useTheme();
  
  const config: RunAgentConfig = {
    agentId,
    configurationVersion,
    teamId,
    shouldNavigateToExecutions,
    onExecutionCreated,
  };

  return (
    <Modal
      title="Run Agent"
      open={open}
      onCancel={onClose}
      width={`${theme.screenSM + 30}px`}
      style={{ top: 0, marginTop: `${theme.marginXL}px` }}
      footer={null}
    >
      <RunAgentComponent
        config={config}
        onClose={onClose}
        onExecutionCreated={onExecutionCreated}
      />
    </Modal>
  );
};

export default RunAgentModal; 